(ns frontend.view.settings2.web-form.properties                                                     ;; TODO: remove if not used
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.assets :as assets]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [common.util :as cu]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.utils :as fu]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [frontend.view.profile.view :as profile]
   [frontend.view.settings2.web-form.events :as events]
   [oops.core :as oops]
   [potpuri.core :refer [fn->]]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [ui.components.button.view :as button]
   [ui.components.radio-group.view :as radio-group]
   [ui.components.rich-text.tiptap :as tiptap]
   [ui.components.toggle.view :as toggle]
   [ui.dom-globals :as dg]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn name-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/display-name
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (let [fs (registry/get-field-schema @session/tenant-schema
                                                      attribute)]
                    (loc/field-name attribute fs))
       :data-type :data.type/text-simple
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur   (fn [new-value]
                    (events/save-webform!
                     webentry
                     attribute
                     new-value
                     (fn [_]
                       (logging/info "Update successful!"))
                     (fn [err]
                       (logging/error "Failed to update " err))))}]]))

(defn asset-type-selector
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/asset-type
        options (->> assets/target-asset-type-mappings
                     :entity.type/oppo
                     (keep (fn [at]
                             (when (session/asset-type-feature? at)
                               {:value at
                                :label (->> entity-type-names/entities
                                            at
                                            :field/translations
                                            :en)})))
                     (vec))
        old-value (get webentry attribute)
        ;;default-asset-type:
        asset-type (or old-value :entity.type/company)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :web-form-settings/asset-type)
       :data-type :data.type/keyword
       :value     (->> options
                       (cu/filter-by :value asset-type)
                       (first))
       :options   options
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}]]))

(defn handler-selector
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/handler-account
        accounts (->> (session/tenant-users)
                      (sort-by (fn-> entity/display-string string/lower-case)))
        options (->> accounts
                     (map (fn [c]
                            {:value (:db/id c)
                             :label (entity/display-string c :long)})))
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :web-form-settings/default-owner-label)
       :data-type :data.type/ref-single
       :value     (->> options
                       (cu/filter-by :value old-value)
                       (first))
       :options   options
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Updating default owner was successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update default owner " err)))))}]
     [:span {:class "text-xs"} (loc/tr :web-form-settings/set-default-owner)]]))

(defn pipeline-selector
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/default-pipeline
        options (->> @session/all-oppo-pipelines
                     (filter (fn [p]
                               (some #{:entity.type/company
                                       :entity.type/fof-asset
                                       :entity.type/real-estate
                                       :entity.type/other-asset}
                                     (->> p
                                          :pipeline/target-asset-types))))
                     (map (fn [p]
                            {:value (:db/id p)
                             :label (entity/display-string p)}))
                     (doall))
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :web-form-settings/set-default-pipeline)
       :data-type :data.type/ref-single
       :value     (->> options
                       (cu/filter-by :value old-value)
                       (first))
       :options   options
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Updating pipeline was successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update pipeline " err)))))}]]))

(defn embed-toggle
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/embed
        old-value (get webentry attribute)]
    [:div
     [toggle/toggle
      {:checked?  (boolean old-value)
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}]]))

(defn language-selector
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/language
        options (->> languages/options
                     (filter
                      (fn [{:keys [keyword]}]
                        (contains? #{:ENG :FIN} keyword))))
        old-value (get @entity-atom attribute)]
    [:div
     [labelled-input/view
      {:label     ""
       :data-type :data.type/keyword
       :value     (->> options
                       (cu/filter-by :value old-value)
                       (first))
       :options   options
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}]]))

(defn attachments-selector
  [{:keys [webentry entity-atom]}]
  (let [tenant-schema @session/tenant-schema
        attribute :webentry/document-config
        field-schema (registry/get-field-schema tenant-schema attribute)
        old-value (get webentry attribute)
        options (->> (get field-schema :options)
                     (mapv (fn [p]
                             {:value   (:key p)
                              :content (:label p)})))
        document (or old-value :webentry.documents/pdf)]
    [:div
     {:class "flex gap-6 mb-2"}
     [radio-group/radio-group-v2
      {:checked     document
       :orientation :horizontal
       :name        (loc/tr :web-form-settings/allow-docs)
       :on-change   (fn [new-value]
                      (cond
                        (= new-value :webentry.documents/any)
                        (modals/open-modal!
                         confirmation/modal-key
                         {:body           (loc/tr :webentry.documents-confirm/any)
                          :confirm-text   (loc/tr :confirm)
                          :confirm-icon   ""
                          :skip-checkbox? true
                          :on-confirm     (fn [_]
                                            (swap! entity-atom assoc attribute new-value)
                                            (events/save-webform!
                                             webentry
                                             attribute
                                             new-value
                                             (fn [_]
                                               (logging/info "Update successful!"))
                                             (fn [err]                                              ;;retract the optimistic save above
                                               (when (= new-value (get @entity-atom attribute))
                                                 (swap! entity-atom assoc attribute old-value))
                                               (logging/error "Failed to update " err))))})
                        :else
                        (when-not (= new-value old-value)
                          (swap! entity-atom assoc attribute new-value)
                          (events/save-webform!
                           webentry
                           attribute
                           new-value
                           (fn [_]
                             (logging/info "Update successful!"))
                           (fn [err]                                                                ;;retract the optimistic save above
                             (when (= new-value (get @entity-atom attribute))
                               (swap! entity-atom assoc attribute old-value))
                             (logging/error "Failed to update " err))))))}
      options]]))

(defn n-attachments-selector
  [{:keys [webentry]}]
  (let [n-attachments-config-state (r/atom (or (-> webentry
                                                   :webentry/n-attachments-config
                                                   vec)
                                               []))
        on-save (fn []
                  (events/save-webform!
                   webentry
                   :webentry/n-attachments-config
                   @n-attachments-config-state
                   (fn [] (js/console.log "Saved :webentry/n-attachments-config"))
                   (fn [] (js/console.log "Failed to save :webentry/n-attachments-config"))))]
    (fn [_]
      (js/console.log "type @n-attachments-config-state" (type @n-attachments-config-state))
      [:div {:class ""}
       [:label
        {:class "font-semibold text-xl"}
        (loc/tr :attachments)]
       [:div
        {:class "flex flex-col gap-4"}
        (let [n-attachments-config @n-attachments-config-state]
          (->> n-attachments-config
               (map-indexed
                (fn [i {:keys [label mandatory? pdf-only?]}]
                  ^{:key i}
                  [:div
                   {:class "flex flex-col gap-2 border-l border-solid border-secondary-light-border pl-2"}
                   [:div
                    {:class "w-full flex justify-end"}
                    [:i.fal.fa-times.clickable
                     {:on-click (fn [_e]
                                  (->> n-attachments-config
                                       (drop (inc i))
                                       (concat (take i n-attachments-config))
                                       (constantly)
                                       (swap! n-attachments-config-state))
                                  (on-save))}]]
                   [labelled-input/view
                    {:value     label
                     :data-type :data.type/text-simple
                     :label     (loc/tr :attachment-label)
                     :on-change (fn [new-value]
                                  (swap!
                                   n-attachments-config-state
                                   update-in
                                   [i :label]
                                   (constantly
                                    new-value)))
                     :on-blur   on-save}]
                   [:div
                    {:class "flex items-center justify-between"}
                    [:div {:class "pr-4"} (loc/tr :required)]
                    [toggle/toggle
                     {:checked?  mandatory?
                      :on-change (fn [_]
                                   (swap! n-attachments-config-state update-in [i :mandatory?] not)
                                   (on-save))}]]
                   [:div
                    {:class "flex items-center justify-between"}
                    [:div {:class "pr-4"} (loc/tr :visitors-can-only-send-pdf-files)]
                    [toggle/toggle
                     {:checked?  pdf-only?
                      :on-change (fn [_]
                                   (swap! n-attachments-config-state update-in [i :pdf-only?] not)
                                   (on-save))}]]]))))]
       [button/sm-secondary-hollow
        {:on-click (fn []
                     (swap!
                      n-attachments-config-state
                      (fn [n-attachments-config]
                        (vec (concat n-attachments-config [{}]))))
                     (on-save))
         :class    "mt-2"}
        "+ " (loc/tr :add-attachment)]])))

#_(defn checks-selector
  [{:keys [webentry]}]
  (let [checks-config-state (r/atom (or (:webentry/checks-config webentry) []))
        on-save (fn []
                  (events/save-webform!
                   webentry
                   :webentry/checks-config
                   @checks-config-state
                   (fn [] (js/console.log "Saved :webentry/checks-config"))
                   (fn [] (js/console.log "Failed to save :webentry/checks-config"))))]
    (fn [_]
      (js/console.log "type @checks-config-state" (type @checks-config-state))
      (js/console.log "@checks-config-state" (clj->js @checks-config-state))
      [:div
       [:label
        {:class "font-semibold text-xl"}
        (loc/tr :checkboxes)]
       [:div
        {:class {:class "flex flex-col gap-4"}}
        (->> @checks-config-state
             (map-indexed
              (fn [i {:keys [description]}]
                ^{:key i}
                [:div
                 {:class "flex flex-col gap-2 border-l border-solid border-secondary-light-border pl-2"}
                 [:div
                  {:class "flex justify-end w-full"}
                  [:i.fal.fa-times.clickable
                   {:on-click (fn [_e]
                                (swap!
                                 checks-config-state
                                 (fn [checks-config]
                                   (->> checks-config
                                        (drop (inc i))
                                        (concat (take i checks-config))
                                        (vec))))
                                (on-save))}]]
                 [rich-text/editor
                  {:value     description
                   :on-change (fn [value]
                                (swap!
                                 checks-config-state
                                 update-in
                                 [i :description]
                                 (constantly value)))
                   :on-blur   on-save
                   :border?   true
                   :link?     true}]])))]
       [button/sm-secondary-hollow
        {:class    "mt-2"
         :on-click (fn []
                     (swap!
                      checks-config-state
                      (fn [n-attachments-config]
                        (vec (concat n-attachments-config [{}]))))
                     (on-save))}
        "+ " (loc/tr :add-checkbox)]])))

(defn checks-selector
  [{:keys [webentry]}]
  (let [checks-config-state (r/atom (or (:webentry/checks-config webentry) []))
        on-save (fn []
                  (events/save-webform!
                   webentry
                   :webentry/checks-config
                   @checks-config-state
                   (fn [] (js/console.log "Saved :webentry/checks-config"))
                   (fn [] (js/console.log "Failed to save :webentry/checks-config"))))]
    (fn [_]
      (js/console.log "type @checks-config-state" (type @checks-config-state))
      (js/console.log "@checks-config-state" (clj->js @checks-config-state))
      [:div
       [:label
        {:class "font-semibold text-xl"}
        (loc/tr :checkboxes)]
       [:div
        {:class "flex flex-col gap-4"}
        (->> @checks-config-state
             (map-indexed
              (fn [i {:keys [description]}]
                ^{:key i}
                [:div
                 {:class "flex flex-col gap-2 border-l border-solid border-secondary-light-border pl-2"}
                 [:div
                  {:class "flex justify-end w-full"}
                  [:i
                   {:class "fal fa-times clickable"
                    :on-click (fn [_e]
                                (swap!
                                 checks-config-state
                                 (fn [checks-config]
                                   (->> checks-config
                                        (drop (inc i))
                                        (concat (take i checks-config))
                                        (vec))))
                                (on-save))}]]
                 [tiptap/editor
                  {:value description
                   :on-change (fn [value]
                                (swap!
                                 checks-config-state
                                 update-in
                                 [i :description]
                                 (constantly value)))
                   :on-blur on-save
                   :link? true
                   :show-block-type? false
                   :inline-options [:bold :italic :underline]}]])))]
       [button/sm-secondary-hollow
        {:class "mt-2"
         :on-click (fn []
                     (swap!
                      checks-config-state
                      (fn [n-attachments-config]
                        (vec (concat n-attachments-config [{}]))))
                     (on-save))}
        "+ " (loc/tr :add-checkbox)]])))

(defn show-your-message-toggle
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/show-your-message
        old-value (get webentry attribute)]
    [:div
     [toggle/toggle
      {:checked?  (boolean old-value)
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err]                                                                    ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}]]))

(defn embed-code
  [{:keys [webentry hide-code?]}]
  (let [{:keys [webentry/apikey]} webentry
        origin (str (oops/oget (dg/location) "origin") "/")
        webentry-address-start (str origin "webentry/")
        url (str webentry-address-start (fu/sanitize-text apikey))
        style "style=\"width:800px;height:600px;\""
        code (str "<iframe src=\"" url "\" " style "></iframe>")]
    [:div
     (when-not hide-code?
       [:span
        code])
     (if hide-code?
       [button/secondary-hollow
        {:on-click (fn [e]
                     (dg/prevent-and-stop e)
                     (clipboard/copy-to code))}
        (loc/tr :web-form-settings/copy-embed-to-clipboard)]
       [:span

        [button/secondary-open
         [:i.fal.fa-copy
          {:tooltip  (loc/tr :copy-to-clipboard)
           :on-click (fn [e]
                       (dg/prevent-and-stop e)
                       (clipboard/copy-to code))}]]])]))

(defn request-submitters-input
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/email-opt-in-title
        old-value (get webentry attribute)]
    [:div
     [labelled-input/view
      {:label     (loc/tr :webentry/request-for-submitters)
       :data-type :data.type/text-simple
       :value     old-value
       :on-change (fn [new-value]
                    (swap! entity-atom assoc attribute new-value))
       :on-blur   (fn [new-value]
                    (events/save-webform!
                     webentry
                     attribute
                     new-value
                     (fn [_]
                       (logging/info "Update successful!"))
                     (fn [err]
                       (logging/error "Failed to update " err))))}]]))

(defn email-opt-in-toggle
  [{:keys [webentry entity-atom]}]
  (let [attribute :webentry/email-opt-in
        old-value (get webentry attribute)]
    [:div
     [toggle/toggle
      {:checked?  (boolean old-value)
       :on-change (fn [new-value]
                    (when-not (= new-value old-value)
                      (swap! entity-atom assoc attribute new-value)
                      (events/save-webform!
                       webentry
                       attribute
                       new-value
                       (fn [_]
                         (logging/info "Update successful!"))
                       (fn [err]
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute old-value))
                         (logging/error "Failed to update " err)))))}]]))

(defn view
  [{:keys [_webentry _entity-atom _system-form?]}]
  (let [state-atom (r/atom {})
        available-asset-types (->> assets/all-asset-types
                                   (filter session/asset-type-feature?)
                                   (vec))]
    (fn [{:keys [webentry entity-atom system-form?]}]
      (let [{:keys [webentry/embed webentry/email-opt-in]} @entity-atom]
        (if (= :webentry.type/custom (:webentry/type webentry))
          [:div
           [:p (loc/tr :custom-webform-info)]
           [:div
            [:div
             [:div
              {:class "mb-3"}
              [:label
               (loc/tr :web-form-settings/unique-url)]
              [profile/web-form-address (fu/cs "settings2-webentry-address") webentry true]]
             [:div
              {:class "mb-3"}
              [handler-selector
               {:webentry    webentry
                :entity-atom entity-atom
                :state-atom  state-atom}]]
             [:div
              {:class "mb-3"}
              [pipeline-selector
               {:webentry    webentry
                :entity-atom entity-atom
                :state-atom  state-atom}]]]]]
          [:div
           {:class "grid grid-cols-1 gap-4"}
           [:div
            [:div
             {:class "flex flex-col gap-4"}

             [:div
              [:div
               {:class "font-semibold text-xl"}
               (loc/tr :web-form-settings/title-general-settings)]]

             [:div
              [name-input
               {:webentry    webentry
                :entity-atom entity-atom
                :state-atom  state-atom}]]
             (when (> (count available-asset-types) 1)
               ;;note: only company for first release
               [:div
                [asset-type-selector
                 {:webentry    webentry
                  :state-atom  state-atom
                  :entity-atom entity-atom}]])

             [:div
              [handler-selector
               {:webentry    webentry
                :entity-atom entity-atom
                :state-atom  state-atom}]]

             [:div
              {:class "flex flex-col gap-3"}
              [:label
               (loc/tr :web-form-settings/allow-docs)]
              [attachments-selector
               {:webentry    webentry
                :entity-atom entity-atom
                :state-atom  state-atom}]]

             [:div 
              [:div
               {:class "inline-flex justify-between items-center gap-3"}
               [show-your-message-toggle
                {:webentry    webentry
                 :entity-atom entity-atom
                 :state-atom  state-atom}]
               [:label
                (loc/tr :web-form-settings/show-your-message)]]]

             [:div
              [:div
               {:class "inline-flex justify-between items-center gap-3"}
               [embed-toggle
                {:webentry    webentry
                 :entity-atom entity-atom
                 :state-atom  state-atom}]
               [:label
                (loc/tr :web-form-settings/allow-embed)]]
              (when embed
                [:div
                 {:class "py-4"}
                 [embed-code
                  {:webentry   webentry
                   :hide-code? true}]])]

             (when (tenant-customizations/innovestor?)
               [:div
                [n-attachments-selector
                 {:webentry    webentry
                  :entity-atom entity-atom
                  :state-atom  state-atom}]])

             (when (some #{:person/email-opt-in} (:tenant/fields-in-use @session/tenant))
               [:div
                [:div
                 {:class "flex justify-between items-center"}
                 [:label
                  (loc/tr :web-form-settings/collect-email-opt-in)]
                 [email-opt-in-toggle
                  {:webentry    webentry
                   :entity-atom entity-atom
                   :state-atom  state-atom}]]
                (when email-opt-in
                  [:div
                   {:class "mt-3"}
                   [request-submitters-input
                    {:webentry    webentry
                     :entity-atom entity-atom
                     :state-atom  state-atom}]])])

             (when (tenant-customizations/innovestor?)
               [:div
                [checks-selector
                 {:webentry    webentry
                  :entity-atom entity-atom
                  :state-atom  state-atom}]])

             (when (tenant-customizations/innovestor?)
               [alert/info
                {}
                [:span
                 (loc/tr :web-form-settings/language)
                 [language-selector
                  {:webentry    webentry
                   :entity-atom entity-atom
                   :state-atom  state-atom}]]])

             (when-not system-form?
               [:div
                [button/danger-solid
                 {:class    "mt-3"
                  :on-click (partial events/start-delete-webform! webentry)}
                 [:span (loc/tr :web-form-settings/delete-permanently)]]])]]])))))
